import styled from 'styled-components';

export const PromoBannerWrap = styled.div`
  background: linear-gradient(90deg, #292b38 0%, #23243a 100%);
  border-radius: 20px;
  padding: 30px 28px 28px 28px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  flex-wrap: wrap;
  position: relative;
  color: #fff;
  font-weight: 500;
  min-height: 70px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px 6px 10px 6px;
    min-height: unset;
  }
`;

export const PromoLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1;
  @media (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 0;
  }
`;

export const PromoLabel = styled.span`
  font-size: 22px;
  font-weight: 700;
  white-space: nowrap;
  @media (max-width: 600px) {
    font-size: 15px;
  }
`;

export const PromoCode = styled.span`
  background: #0080FF;
  color: #fff;
  border-radius: 12px;
  padding: 6px 18px;
  cursor: ${({ applied }) => (applied ? 'default' : 'pointer')};
  font-weight: 800;
  font-size: 22px;
  letter-spacing: 1.5px;
  transition: background 0.2s;
  user-select: all;
  min-height: 38px;
  display: flex;
  align-items: center;
  @media (max-width: 600px) {
    font-size: 16px;
    padding: 4px 10px;
    min-height: 28px;
  }
`;

export const PromoBonus = styled.span`
  margin-left: 12px;
  color: #FFD700;
  font-weight: 700;
  font-size: 20px;
  white-space: nowrap;
  @media (max-width: 600px) {
    font-size: 14px;
    margin-left: 0;
    margin-top: 2px;
  }
`;

export const PromoRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 120px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    min-width: 0;
    gap: 6px;
  }
`;

export const PromoButton = styled.button`
  background: #0080FF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 8px 28px;
  font-weight: 700;
  font-size: 18px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  margin-bottom: 2px;
  min-height: 38px;
  transition: background 0.2s;
  @media (max-width: 600px) {
    margin-bottom: 0;
    padding: 7px 18px;
    font-size: 15px;
    min-width: 110px;
  }
  &:hover {
    background: #0066cc;
  }
`;

export const PromoTimer = styled.span`
  color: #FFD700;
  font-weight: 600;
  font-size: 15px;
  margin-top: 2px;
  text-align: right;
  @media (max-width: 600px) {
    margin-top: 0;
    font-size: 14px;
    margin-left: 10px;
    text-align: left;
  }
`;

export const PromoTimerBadge = styled.span`
  position: absolute;
  top: -12px;
  right: 16px;
  background: #FFD700;
  color: #23243a;
  font-weight: 700;
  font-size: 15px;
  border-radius: 8px;
  padding: 3px 12px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  @media (max-width: 600px) {
    top: -6px;
    right: 8px;
    font-size: 12px;
    padding: 2px 7px;
  }
`;

// Для бонуса в списке пакетов
export const PackAmount = styled.span`
  color: ${props => props.theme.text.primary};
  font-size: clamp(14px, 3.5vw, 18px);
  font-weight: 500;
  display: flex;
  align-items: center;
  line-height: 1;
  vertical-align: middle;
  & svg, & img {
    vertical-align: middle;
    margin-right: 4px;
  }
`;

export const PackBonus = styled.span`
  color: #FFD700;
  font-weight: 700;
  font-size: clamp(14px, 3.5vw, 12px);
  margin-left: 8px;
  display: flex;
  align-items: center;
  line-height: 1;
  vertical-align: middle;
  & svg, & img {
    vertical-align: middle;
    margin-right: 4px;
  }
`;

export const RubBlock = styled.span`
  color: #A0A0A0;
  font-size: clamp(13px, 3vw, 12px);
  font-weight: 500;
  margin-right: 8px;
  display: flex;
  align-items: center;
  line-height: 1;
  vertical-align: middle;
`;

export const PackPrice = styled.span`
  color: ${props => props.theme.text.secondary};
  font-size: clamp(13px, 3vw, 14px);
  display: flex;
  align-items: center;
  line-height: 1;
  vertical-align: middle;
`;

export const PackItem = styled.button`
  background: ${props => props.theme.card.background};
  border: none;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  text-align: left;
  &:active {
    opacity: 0.8;
  }
`;

export const PackLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PackRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PacksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`; 